import { BETA_MODE } from "../config";

export const BetaBadge = () => {
  if (!BETA_MODE) return null;
  return (
    <span
      className="ml-2 px-2 py-0.5 rounded-full text-[9px] font-bold tracking-widest flex-shrink-0"
      style={{ background: "#F5CB5C", color: "#2A1E5C" }}
      data-testid="beta-header-badge"
    >
      BETA
    </span>
  );
};

export const BetaCodeNote = ({ light = false, className = "" }) => {
  if (!BETA_MODE) return null;
  return (
    <p
      className={`font-body text-[11px] text-center mt-2 ${className}`}
      style={{ color: light ? "rgba(255,255,255,0.75)" : "#8B7E6A" }}
      data-testid="beta-code-note"
    >
      🎟️ Beta racer? Your beta code works at checkout.
    </p>
  );
};
